import { type PropsWithChildren, useMemo } from 'react';

import { env } from '@/config/env';
import { authService } from '@/features/auth/services/authServiceFactory';
import { ApiClient } from '@/lib/api';

import { HttpCustomerProfileApi, MockCustomerProfileApi, type CustomerProfileApi } from '../api';
import { CustomerProfileApiContext } from './customerProfileApiContext';

export function CustomerProfileApiProvider({
  children,
  api,
}: PropsWithChildren<{ api?: CustomerProfileApi }>) {
  const value = useMemo(
    () =>
      api ??
      (env.authMode === 'mock'
        ? new MockCustomerProfileApi(authService)
        : new HttpCustomerProfileApi(new ApiClient(env.apiBaseUrl, authService))),
    [api],
  );
  return (
    <CustomerProfileApiContext.Provider value={value}>
      {children}
    </CustomerProfileApiContext.Provider>
  );
}
